'use client';

import { c as _c } from "react/compiler-runtime";
import BackgroundImage from '@components/background-image/BackgroundImage';
import SVGelem from '@components/SVGelem/SVGelem';
import VideoButton from '@components/video-button/VideoButton';
import PanoramaEvening from '@images/panorama/1_full.webp';
import PanoramaMorning from '@images/panorama/2_full.webp';
import PanoramaAfternoon from '@images/panorama/3_full.webp';
import Panorama from '@images/renders/bg_images/panorama.webp';
import Panorama_mob from '@images/renders/bg_images/panorama_mob.webp';
import PanoramaPlug from '@images/renders/bg_images/panorama_plug.webp';
import { handlePanoramaModel, handlepanoramaImgsLoading, startPanoramaPreloadSelector } from '@lib/store/slices/ComponentsSlice';
import { preloadImages } from '@lib/tools/_preload-images';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import style from './MainPanorama.module.scss';
function MainPanorama(t0) {
  const $ = _c(27);
  const {
    isMobile
  } = t0;
  const [iconHover, setIconHover] = useState(false);
  const dispatch = useDispatch();
  const startPreload = useSelector(startPanoramaPreloadSelector);
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => dispatch(handlePanoramaModel(true));
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenModaPanorama = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIconHover(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleMouseOver = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIconHover(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleMouseOut = t3;
  let t4;
  if ($[4] !== dispatch || $[5] !== startPreload) {
    t4 = () => {
      if (startPreload) {
        const panoramaImages = [PanoramaMorning.src, PanoramaAfternoon.src, PanoramaEvening.src];
        const imgs = preloadImages(panoramaImages);
        imgs.then(response => {
          dispatch(handlepanoramaImgsLoading(response));
        }).catch(error => {
          if (error.message === "Image load timeout") {} else {
            dispatch(handlepanoramaImgsLoading("error"));
          }
        });
      }
    };
    $[4] = dispatch;
    $[5] = startPreload;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== startPreload) {
    t5 = [startPreload];
    $[7] = startPreload;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t4, t5);
  const t6 = !isMobile ? Panorama : Panorama_mob;
  let t7;
  if ($[9] !== t6) {
    t7 = <div className={style.sixthScreenContainerImg}><BackgroundImage src={t6} name="panorama" imagePlug={PanoramaPlug} /></div>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={style.sixthScreenTitle}>Квартиры с видом на зелёный океан</div>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== iconHover) {
    t9 = !iconHover && <SVGelem className={style.svgClass} href="#eye_icon" />;
    $[12] = iconHover;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== iconHover) {
    t10 = iconHover && <SVGelem className={style.svgClass} href="#eye_icon_black" />;
    $[14] = iconHover;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className={style.sixthScreenIcon} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onFocus={_temp} onBlur={_temp2}>{t9}{t10}</div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={style.sixthScreenText}>смотреть панораму 360°</div>;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== handleOpenModaPanorama || $[21] !== t11) {
    t13 = <div className={style.sixthScreenBox} onClick={handleOpenModaPanorama} role="button" tabIndex="0">{t11}{t12}</div>;
    $[20] = handleOpenModaPanorama;
    $[21] = t11;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className={style.videoButton}><VideoButton video="lapse" white={true} text={"\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0437\u0430\u043A\u0430\u0442\u044B"} /></div>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13 || $[25] !== t7) {
    t15 = <div data-scroll={true} id="fixed-target-six" className={style.sixthScreenContainer}>{t7}{t8}{t13}{t14}</div>;
    $[24] = t13;
    $[25] = t7;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
}
function _temp2() {}
function _temp() {}
export default MainPanorama;